import {useAppSelector} from "./useAppSelector";

export const useContentError = (): [error?: string] => {
    const translationsError = useAppSelector(state => state.translations.errorMessage);
    return [translationsError];
}
